module.exports = __webpack_public_path__ + "static/media/BioChemistryIcon.28bc4d64.svg";